var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "inlineProductPicker",
      staticClass: "sp-inline-picker",
      class: { "sp-inline-picker--auto-fill": _vm.isAutoFillMode },
      style: _vm.inlineProductPickerStyle,
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _vm.isAutoFillMode
        ? _c("div", { staticClass: "sp-inline-picker__auto-head" }, [
            _c("div", { staticClass: "sp-inline-picker__auto-title" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", { attrs: { d: "m14 7 3 3" } }),
                  _vm._v(" "),
                  _c("path", { attrs: { d: "M5 6v4" } }),
                  _vm._v(" "),
                  _c("path", { attrs: { d: "M19 14v4" } }),
                  _vm._v(" "),
                  _c("path", { attrs: { d: "M10 2v2" } }),
                  _vm._v(" "),
                  _c("path", { attrs: { d: "M7 8H3" } }),
                  _vm._v(" "),
                  _c("path", { attrs: { d: "M21 16h-4" } }),
                  _vm._v(" "),
                  _c("path", { attrs: { d: "M11 3H9" } }),
                ]
              ),
              _vm._v("\n      Auto Fill Display\n    "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sp-inline-picker__auto-subtitle" }, [
              _vm._v(
                "\n      Pick one or more products to populate every shelf.\n    "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sp-inline-picker__source-tabs" },
        _vm._l(_vm.productSources, function (source) {
          return _c(
            "button",
            {
              key: source.value,
              staticClass: "sp-inline-picker__source-tab",
              class: { active: _vm.currentProductSource === source.value },
              attrs: { type: "button", disabled: source.disabled },
              on: {
                click: function ($event) {
                  return _vm.switchProductSource(source.value)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(source.label) + "\n    ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sp-inline-picker__search" }, [
        _c(
          "svg",
          {
            attrs: {
              width: "14",
              height: "14",
              viewBox: "0 0 14 14",
              fill: "none",
              "aria-hidden": "true",
            },
          },
          [
            _c("circle", {
              attrs: {
                cx: "5.8",
                cy: "5.8",
                r: "4.3",
                stroke: "currentColor",
                "stroke-width": "1.4",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M9 9l3 3",
                stroke: "currentColor",
                "stroke-width": "1.4",
                "stroke-linecap": "round",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inlineProductSearch,
              expression: "inlineProductSearch",
            },
          ],
          ref: "inlineProductSearchInput",
          staticClass: "sp-inline-picker__input",
          attrs: { placeholder: _vm.searchPlaceholder },
          domProps: { value: _vm.inlineProductSearch },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.inlineProductSearch = $event.target.value
              },
              _vm.refreshInlineProductSearch,
            ],
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              )
                return null
              return _vm.closeInlineProductPicker.apply(null, arguments)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sp-inline-picker__list" },
        [
          !_vm.isAutoFillMode &&
          !_vm.inlineProductPickerLoading &&
          _vm.hasInlineProductRecents &&
          _vm.inlineProductItems.length &&
          _vm.currentProductSource === _vm.productSourceTypes.REGULAR
            ? [
                _c(
                  "div",
                  { staticClass: "sp-inline-picker__section-heading" },
                  [
                    _c(
                      "span",
                      { staticClass: "sp-inline-picker__section-title" },
                      [_vm._v("Recent")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "sp-inline-picker__clear-recents",
                        attrs: {
                          type: "button",
                          disabled: _vm.inlineProductPickerSaving,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.clearInlineProductRecents.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [_vm._v("\n          Clear\n        ")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.visibleInlineProductRecentItems, function (item) {
                  return _c(
                    "button",
                    {
                      key: `recent-${_vm.productItemKey(item)}`,
                      staticClass: "sp-inline-picker__item",
                      attrs: {
                        type: "button",
                        disabled: _vm.inlineProductPickerSaving,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectInlineProduct(item, {
                            fromRecent: true,
                          })
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "sp-inline-picker__thumb" }, [
                        _vm.productItemThumbnail(item)
                          ? _c("img", {
                              attrs: {
                                src: _vm.productItemThumbnail(item),
                                alt: _vm.productItemName(item),
                              },
                            })
                          : _c("span", {
                              staticClass:
                                "sp-inline-picker__thumb-placeholder",
                            }),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sp-inline-picker__copy" }, [
                        _c("span", { staticClass: "sp-inline-picker__name" }, [
                          _vm._v(_vm._s(_vm.productItemName(item))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "sp-inline-picker__code" }, [
                          _vm._v(_vm._s(_vm.productItemCode(item))),
                        ]),
                      ]),
                    ]
                  )
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.currentProductSource === _vm.productSourceTypes.UPLOADS
            ? _c(
                "div",
                {
                  staticClass: "px-1 pt-1",
                  on: {
                    dragenter: function ($event) {
                      $event.preventDefault()
                      return _vm.onDragEnter.apply(null, arguments)
                    },
                    dragover: function ($event) {
                      $event.preventDefault()
                      return _vm.onDragOver.apply(null, arguments)
                    },
                    dragleave: function ($event) {
                      $event.preventDefault()
                      return _vm.onDragLeave.apply(null, arguments)
                    },
                    drop: function ($event) {
                      $event.preventDefault()
                      return _vm.onDrop.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "px-2 py-2 text-center custom-drag-drop-area",
                      class: {
                        "custom-drag-drop-area--active": _vm.isDraggingOver,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.fileInput.click()
                        },
                      },
                    },
                    [_vm._m(0)]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    ref: "fileInput",
                    staticClass: "product-picker__file-input",
                    attrs: { type: "file", accept: "image/*" },
                    on: { change: _vm.onFileSelected },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.inlineProductPickerLoading && _vm.inlineProductItems.length
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "sp-inline-picker__section-title sp-inline-picker__section-title--all",
                  },
                  [_vm._v("\n        All products\n      ")]
                ),
                _vm._v(" "),
                _vm._l(_vm.inlineProductItems, function (item) {
                  return _c(
                    "div",
                    {
                      key: _vm.productItemKey(item),
                      staticClass: "sp-inline-picker__item",
                      class: {
                        "sp-inline-picker__item--selectable":
                          _vm.isAutoFillMode,
                        selected:
                          _vm.isAutoFillMode &&
                          _vm.isAutoFillProductSelected(item),
                      },
                      attrs: { role: "button", tabindex: "0" },
                      on: {
                        click: function ($event) {
                          return _vm.handleProductItemClick(item)
                        },
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          $event.preventDefault()
                          return _vm.handleProductItemClick(item)
                        },
                      },
                    },
                    [
                      _vm.isAutoFillMode
                        ? _c("input", {
                            staticClass: "sp-inline-picker__checkbox",
                            attrs: {
                              type: "checkbox",
                              disabled: _vm.inlineProductPickerSaving,
                            },
                            domProps: {
                              checked: _vm.isAutoFillProductSelected(item),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                              change: function ($event) {
                                $event.stopPropagation()
                                return _vm.toggleAutoFillProduct(item)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "sp-inline-picker__thumb" }, [
                        _vm.productItemThumbnail(item)
                          ? _c("img", {
                              attrs: {
                                src: _vm.productItemThumbnail(item),
                                alt: _vm.productItemName(item),
                              },
                            })
                          : _c("span", {
                              staticClass:
                                "sp-inline-picker__thumb-placeholder",
                            }),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sp-inline-picker__copy" }, [
                        _c("span", { staticClass: "sp-inline-picker__name" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.productItemName(item)) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "sp-inline-picker__code" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.productItemCode(item)) +
                              "\n          "
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.inlineProductPickerLoading
            ? _c("div", { staticClass: "sp-inline-picker__state" }, [
                _vm._v("\n      Loading products...\n    "),
              ])
            : !_vm.inlineProductItems.length
            ? _c("div", { staticClass: "sp-inline-picker__state" }, [
                _vm._v("\n      No products found\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.inlineProductPickerError
            ? _c(
                "div",
                {
                  staticClass:
                    "sp-inline-picker__state sp-inline-picker__state--error",
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.inlineProductPickerError) + "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sp-inline-picker__footer" },
        [
          _c(
            "button",
            {
              staticClass: "sp-inline-picker__pager-btn",
              attrs: {
                type: "button",
                disabled:
                  _vm.inlineProductPickerLoading ||
                  _vm.inlineProductCurrentPage <= 1,
                "aria-label": "First page",
              },
              on: {
                click: function ($event) {
                  return _vm.goToInlineProductPage(1)
                },
              },
            },
            [_vm._v("\n      «\n    ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "sp-inline-picker__pager-btn",
              attrs: {
                type: "button",
                disabled:
                  _vm.inlineProductPickerLoading ||
                  _vm.inlineProductCurrentPage <= 1,
                "aria-label": "Previous page",
              },
              on: {
                click: function ($event) {
                  return _vm.goToInlineProductPage(
                    _vm.inlineProductCurrentPage - 1
                  )
                },
              },
            },
            [_vm._v("\n      ‹\n    ")]
          ),
          _vm._v(" "),
          _vm._l(_vm.inlineProductPagerPages, function (page, index) {
            return [
              page === "ellipsis"
                ? _c(
                    "span",
                    {
                      key: `ellipsis-${index}`,
                      staticClass: "sp-inline-picker__pager-ellipsis",
                    },
                    [_vm._v("\n        ...\n      ")]
                  )
                : _c(
                    "button",
                    {
                      key: `page-${page}`,
                      staticClass:
                        "sp-inline-picker__pager-btn sp-inline-picker__pager-btn--page",
                      class: { active: page === _vm.inlineProductCurrentPage },
                      attrs: {
                        type: "button",
                        disabled: _vm.inlineProductPickerLoading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.goToInlineProductPage(page)
                        },
                      },
                    },
                    [_vm._v("\n        " + _vm._s(page) + "\n      ")]
                  ),
            ]
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "sp-inline-picker__pager-btn",
              attrs: {
                type: "button",
                disabled:
                  _vm.inlineProductPickerLoading ||
                  _vm.inlineProductCurrentPage >= _vm.inlineProductLastPage,
                "aria-label": "Next page",
              },
              on: {
                click: function ($event) {
                  return _vm.goToInlineProductPage(
                    _vm.inlineProductCurrentPage + 1
                  )
                },
              },
            },
            [_vm._v("\n      ›\n    ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "sp-inline-picker__pager-btn",
              attrs: {
                type: "button",
                disabled:
                  _vm.inlineProductPickerLoading ||
                  _vm.inlineProductCurrentPage >= _vm.inlineProductLastPage,
                "aria-label": "Last page",
              },
              on: {
                click: function ($event) {
                  return _vm.goToInlineProductPage(_vm.inlineProductLastPage)
                },
              },
            },
            [_vm._v("\n      »\n    ")]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isAutoFillMode
        ? _c("div", { staticClass: "sp-inline-picker__auto-footer" }, [
            _vm.shouldShowAutoFillModePicker
              ? _c("div", { staticClass: "sp-inline-picker__fill-mode" }, [
                  _c(
                    "button",
                    {
                      staticClass: "sp-inline-picker__fill-mode-btn",
                      class: { active: _vm.autoFillMode === "replace-all" },
                      attrs: {
                        type: "button",
                        disabled: _vm.inlineProductPickerSaving,
                      },
                      on: {
                        click: function ($event) {
                          _vm.autoFillMode = "replace-all"
                        },
                      },
                    },
                    [_vm._v("\n        Replace all\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "sp-inline-picker__fill-mode-btn",
                      class: { active: _vm.autoFillMode === "empty-only" },
                      attrs: {
                        type: "button",
                        disabled: _vm.inlineProductPickerSaving,
                      },
                      on: {
                        click: function ($event) {
                          _vm.autoFillMode = "empty-only"
                        },
                      },
                    },
                    [_vm._v("\n        Empty shelves only\n      ")]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "sp-inline-picker__auto-actions" }, [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "span",
                  { staticClass: "sp-inline-picker__selected-count mr-2" },
                  [
                    _vm._v(
                      _vm._s(_vm.autoFillSelectedItems.length) + " selected"
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "sp-inline-picker__clear-recents",
                    staticStyle: { "font-size": "11px" },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.clearAutoFillSelectedItems.apply(
                          null,
                          arguments
                        )
                      },
                    },
                  },
                  [_vm._v("\n          Clear\n        ")]
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "sp-inline-picker__submit",
                  attrs: {
                    type: "button",
                    disabled:
                      _vm.inlineProductPickerSaving ||
                      !_vm.autoFillSelectedItems.length,
                  },
                  on: { click: _vm.submitAutoFill },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "aria-hidden": "true",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "m14 7 3 3" } }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "M5 6v4" } }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "M19 14v4" } }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "M10 2v2" } }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "M7 8H3" } }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "M21 16h-4" } }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "M11 3H9" } }),
                    ]
                  ),
                  _vm._v("\n        Auto Fill\n      "),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pointer-events-none" }, [
      _c("i", { staticClass: "bi bi-upload mr-1" }),
      _vm._v("Drop images or click to upload\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }